<template>
  <div class="invitation">
    <div class="overlay" />
    <div v-click-outside="close" class="invitation__wrap">
      <div class="invitation__title">
        {{ invite.title }}
      </div>
      <div class="invitation__link-wrap">
        <input
          class="invitation__link-text-wrap"
          type="text"
          :value="invite.link"
          readonly
        >
        <button class="invitation__link-copy-wrap" :title="$t('copyLink')" @click="copy" />
        <!--        <button class="invitation__link-share-wrap" />-->
      </div>
      <div class="invitation__close" @click="close" />
    </div>
  </div>
</template>

<script>
import clipboardCopy from 'clipboard-copy';
import { toRefs } from '@vue/composition-api';

export default {
  name: 'VideoRoomControlsInvite',
  props: {
    invite: {
      type: Object,
      required: true,
    },
  },
  setup(props, { emit }) {
    const { invite } = toRefs(props);

    function close() {
      emit('close');
    }

    function copy() {
      clipboardCopy(invite.value.link);
      close();
    }

    return {
      copy,
      close,
    };
  },
};
</script>

<style scoped lang="scss">
.invitation {
  .overlay {
    position: fixed;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 5;
  }

  &__wrap {
    width: 22rem;
    max-width: calc(100vw - 2rem);
    padding: 1.5rem;
    background: rgba(36, 36, 38, 0.97);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.09);
    border-radius: 1rem;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
    text-align: left;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 6;
  }

  &__title {
    font-size: 0.9375rem;
    font-weight: 600;
    line-height: 1.3;
    color: rgba(255, 255, 255, 0.9);
    margin-bottom: 1rem;
    padding-right: 1.5rem;
  }

  &__link-wrap {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 0.375rem;
  }

  &__link-text-wrap {
    flex: 1;
    min-width: 0;
    height: 2.25rem;
    color: rgba(255, 255, 255, 0.55);
    padding: 0 0.75rem;
    background: rgba(255, 255, 255, 0.07);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 0.5rem;
    font-size: 0.8125rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: text;
    &:focus, &:active {
      border-color: rgba(10, 130, 217, 0.6);
      outline: none;
    }
  }

  &__link-copy-wrap {
    flex-shrink: 0;
    width: 2.25rem;
    height: 2.25rem;
    background: rgba(10, 130, 217, 0.15) url("../assets/img/icons/copy.svg") no-repeat center;
    border: 1px solid rgba(10, 130, 217, 0.3);
    border-radius: 0.5rem;
    cursor: pointer;
    transition: background-color 0.2s;
    &:hover {
      background-color: rgba(10, 130, 217, 0.28);
    }
    &:focus, &:active {
      outline: none;
    }
  }

  &__link-share-wrap {
    flex-shrink: 0;
    width: 2.25rem;
    height: 2.25rem;
    background: rgba(255, 255, 255, 0.07) url("../assets/img/icons/share.svg") no-repeat center;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 0.5rem;
    cursor: pointer;
    transition: background-color 0.2s;
    &:hover {
      background-color: rgba(255, 255, 255, 0.12);
    }
    &:focus, &:active {
      outline: none;
    }
  }

  &__close {
    width: 1.5rem;
    height: 1.5rem;
    background: rgba(255, 255, 255, 0.08) url("../assets/img/icons/close.svg") no-repeat center;
    background-size: 10px;
    border-radius: 50%;
    position: absolute;
    top: 1rem;
    right: 1rem;
    z-index: 3;
    cursor: pointer;
    transition: background-color 0.2s;
    &:hover {
      background-color: rgba(255, 255, 255, 0.15);
    }
  }
}

@media (max-width: 440px) {
  .invitation {
    &__wrap {
      width: calc(100% - 2rem);
    }
  }
}
</style>

<i18n locale="en" lang="yaml">
copyLink: Copy link
</i18n>

<i18n locale="ru" lang="yaml">
copyLink: Скопировать ссылку
</i18n>
